// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_h8-0";
export var fileCarousel = "_h8-2";
export var removeFileButton = "_h8-1";